<template>
  <div>
    <button class="button large" :class="{'globalSearchIcon':true, 'displaySearch':displaySearchContainer}" @click="toggleSearch">
      <i class="fas fa-times" v-if="displaySearchContainer"></i>
      <i class="fas fa-search" v-else></i>
    </button>
    <transition name="slide">
      <div :class="{'container':true, 'dark':darkBackground, 'mobile':isMobile}" v-show="displaySearchContainer">
        <div class="search-box">
          <input type="text" class="search-field" placeholder="Search reservations..." v-model="searchInput" v-on:keyup.enter="newSearch" ref="search" @focus="focusSearch" @focusout="removeFocus" :disabled="loading"/>
          <transition name="slide-left">
            <i class="far fa-times-circle fa-lg clear-search" @click="clearSearch"
              v-if="searchInput.length > 0"></i>
          </transition>
          <button class="button small" @click="newSearch" :disabled="loading || !searchInput.length > 0">
            <i class="fas fa-search" v-if="!loading"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>
            </button>
            <div v-show="darkBackground" @click="removeFocus">
              <h3 v-if="!isNewSearch && !searchResult.length > 0 && !loading" class="removeCaps">You can search by Email, <br/>Phone Number and Name</h3>
              <h3 v-if="searchResult.length > 0 && !loading">Search Results</h3>
              <h3 v-if="loading">Loading...</h3>
              <h3 v-if="searchInput.length > 0 && !searchResult.length > 0 && !loading && isNewSearch">No Results Found</h3>
            </div>
        </div>
          <div class="search-results" v-if="darkBackground" @scroll="loadMore" @click="removeFocus">
            <ul>
              <span v-for="search in searchResult" @mousedown="openRSVP(search.rsvpID)">
              <li class="search-result">
                  <p class="rsvp">
                    <i class="fas fa-pager"></i>
                    <span>RSVP {{search.rsvpID}}</span>
                    <span :class="['status', search.status]">{{getLabel(search.status)}}</span>
                    <span class="amount">${{search.total}}</span>
                  </p>
                  <hr/>
                  <div class="row">
                    <div class="columns medium-6 small-12">
                      <p class="schedule">
                        <i class="fas fa-calendar-alt"></i>
                        <span>{{search.pickupDate}} {{search.pickupTime}}</span>
                      </p>
                      <p class="pickup"><i class="fas fa-map-marker-alt"></i> <span>{{search.pickupLocation}}</span></p>
                      <p class="dropoff"><i class="fas fa-location-arrow"></i> <span>{{search.dropoffLocation}}</span></p>
                    </div>
                    <div class="columns medium-6 small-12">
                      <p class="customer-id">
                        <i class="fas fa-address-card"></i>
                        <span>{{search.customerID}}</span>
                      </p>
                      <p class="customer-name">
                        <i class="fas fa-user"></i>
                        <span>{{search.customerName}}</span>
                      </p>
                      <p class="customer-email">
                        <i class="fas fa-envelope"></i>
                        <span>{{search.customerEmail}}</span>
                      </p>
                    </div>
                  </div>
              </li>
              </span>
            </ul>
          </div>

          <transition name="slide-up">
            <div class="infinity-loader" v-show="loading && searchResult.length > 0">
              <i class="fas fa-spinner fa-spin"></i> LOADING...
            </div>
          </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import ApiSearchGlobal from '@/modules/api/search-global/'

export default {
  name: "search",
  data() {
    return {
      darkBackground: false,
      isNewSearch: false,
      isMobile: false
    }
  },
  computed: {
    loading() { return this.$store.state.searchGlobal.isLoading },
    searchInput: {
      get () { return this.$store.state.searchGlobal.searchInput },
      set (value) {
        this.$store.commit('searchGlobal/setSearchGlobalInput', value)
      }
    },
    displaySearchContainer() { return this.$store.state.searchGlobal.searchContainer },
    searchResult() { return this.$store.state.searchGlobal.list },
    isLastPage () {
      let searchPage = this.$store.state.searchGlobal
      return (searchPage.currentPage * searchPage.perPage) >= searchPage.maxList
    }
  },
  methods: {
    search() {
      let self = this
      if (self.loading) { return }
      self.$store.commit('searchGlobal/setSearchGlobalIsLoading', true)
      ApiSearchGlobal.search(self, res => {
        self.$store.commit('searchGlobal/setSearchGlobalIsLoading', false)
      })
    },
    newSearch() {
      let self = this
      self.$store.commit('searchGlobal/resetSearchGlobalList')
      self.$store.commit('searchGlobal/setSearchGlobalCurrentPage', 1)
      self.isNewSearch = true
      self.darkBackground = true
      document.body.style.overflow = "hidden"
      self.search()
    },
    clearSearch() {
      let self = this
      if (self.loading) { return }
      self.searchInput = ''
      self.darkBackground = false
      self.isNewSearch = false
      self.$store.commit('searchGlobal/resetSearchGlobalList')
      self.$store.commit('searchGlobal/setSearchGlobalCurrentPage', 1)
    },
    removeFocus() {
      if (this.loading) { return }
      this.darkBackground = false
      document.body.style.overflow = "auto"
      if(!this.searchInput.length > 0) {
        this.clearSearch()
      }
    },
    focusSearch() {
      if (this.loading) { return }
      this.darkBackground = true
      document.body.style.overflow = "hidden"
    },
    openRSVP(id) {
      window.open('#/reservation/' + id, '_blank')
    },
    loadMore(event) {
      if (this.loading) { return }
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 1.5) {
        if (this.isLastPage || this.loading) { return }
         this.$store.commit('searchGlobal/setSearchGlobalCurrentPage', this.$store.state.searchGlobal.currentPage + 1)
         this.search()
      }
    },
    getLabel(item) {
      switch(item) {
        case "ready": return "Ready to go"
        case "onboard": return "On Board"
        case "requires_dispatch": return "Requires Dispatch"
        case "complete": return "Completed"
        default: return item
      }
    },
    toggleSearch() {
      let self = this
      localStorage.setItem('searchField', !self.displaySearchContainer)
      self.$store.commit('searchGlobal/setSearchGlobalContainer', !self.displaySearchContainer)
    },
    setScreenSize() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  },
  mounted() {
    this.clearSearch()
    this.setScreenSize()
    if (!!localStorage.getItem('searchField')) {
      this.$store.commit('searchGlobal/setSearchGlobalContainer', localStorage.getItem('searchField') === 'true')
    }
  },
  created() {
    window.addEventListener("resize", this.setScreenSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.setScreenSize);
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';

.globalSearchIcon {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 13;
  border-radius: 0;
  height: 50px;
  width: 50px;
  box-shadow: -2px -2px 11px 0px #bbb;
  opacity: 0.3;

  &:hover {
    opacity: 1;
  }

  &.displaySearch {
    opacity: 1;
  }
}

.container {
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: fit-content;
  right: 0;
  left: 0;
  margin: 0 auto;
  position: fixed;
  z-index: 13;
  padding-top: 10px;
  transition: all 0s ease-in-out;

  &.dark {
    text-align: center;
    justify-content: normal;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.75);
    transition: all 0.3s ease-in-out;
    .search-field {
      box-shadow: 0px 2px 7px -2px #aaa;
    }
  }

  .search-box {
    position: relative;
    h3 {
      color: #fff;
      text-transform: uppercase;
      margin-top: 15px;
      margin-bottom: 5px;
      &.removeCaps {
        text-transform: initial;
      }
    }
    .search-field {
      width: 300px;
      border-radius: 24px;
      box-shadow: 0px 6px 10px -2px #aaa;
      display: inline-block;
      margin-top: 0;
      padding-left: 20px;
    }
    button {
      display: inline-block;
      margin-left: -44px;
      border-radius: 0 24px 24px 0;
      height: 46px;
      font-size: 17px;
    }
    .clear-search {
      position: absolute;
      top: 0;
      margin-left: -70px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }

  .search-results {
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    width: 100%;
    text-align: center;

    ul {
      width: 650px;
      margin: auto;
      padding: 0;
    }

    a {
      text-decoration: none;
      color: #222;
    }

    .search-result {
      display: block;
      width: 650px;
      text-align: left;
      margin: 17px auto;
      padding: 20px 35px;
      background-color: #fff;
      border-radius: 18px;
      box-shadow: 0px 5px 7px -2px #aaa;
      &:hover {
        background-color: #fff8dc;
        cursor: pointer;
      }

      .columns {
        padding: 5px;
      }

      hr {
        color: #eee;
        opacity: 0.2;
        margin: 10px 0;
      }

      p {
        margin: 2px;
        i {
          margin-right: 5px;
        }
      }

      .rsvp {
        color: #0d79f2;
        font-weight: 700;
        font-size: 14px;
        padding: 5px;
        .amount {
          color: #000;
          float: right;
          font-size: 20px;
          font-weight: 800;
          line-height: 1;
        }
      }

      .schedule {
        i {
          color: #F25E0D;
        }
        span {
          font-weight: 800;
        }
      }

      .pickup {
        i {
          color:#d92626;
        }
        span {
          font-size: 15px;
        }
      }

      .dropoff {
        i {
          color:#26D97A;
          margin-right: 0;
        }
        span {
          font-size: 15px;
        }
      }

      .customer-id {
        i {
          margin-right: 1px;
        }
      }

      .customer-id,
      .customer-name,
      .customer-email {
        i {
          color: #0d79f2;
        }
        span {
          font-size: 15px;
        }
      }

    }
  }

  .search-results::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}

.mobile {
  &.container {
    z-index: 10;
    .search-box {
      .search-field {
        width: calc(100vw - 120px)
      }
    }
    .search-results {
      ul {
        width: 95%;
      }
      .search-result {
        width: 100%;
        padding: 20px;
      }
    }
  }
}

.slide-enter-active, .slide-leave-active { transition: all .2s ease; }
.slide-enter, .slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .container .search-results .search-result span,
  .container .search-results .search-result i {
    font-size: 13px;
  }
  .container .search-results .search-result p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/Search.vue